export default {"src":"/_next/static/media/DNMR.d75055a2.svg","height":18,"width":18};